import styled from 'styled-components';
import Image from 'next/image';
import { FlexColumn, FlexibleDiv } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';
import { tagStyles } from '../../../ui/Typography/styles';
import { Breakpoints } from '../../../../styled/constants';

export const DeveloperContainer = styled(FlexibleDiv)`
  align-items: center;
  margin-bottom: 30px;
  gap: 10px;

  @media (min-width: ${Breakpoints.tablet}px) {
    margin-bottom: 10px;
  }
`;

export const DeveloperImage = styled(Image)`
  width: 60px;
  height: 60px;
  flex: 0 0 auto;

  @media (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

export const DeveloperTitle = styled(Typography)`
  @media (min-width: ${Breakpoints.tablet}px) {
    ${tagStyles.h9}
  }
`;

export const ApartmentsInfoContainer = styled(FlexColumn)`
  gap: 10px;

  @media (min-width: ${Breakpoints.tablet}px) {
    display: block;
    column-count: 2;
    column-gap: 10px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const BuildingInfo = styled.div`
  display: none;

  @media (min-width: ${Breakpoints.tablet}px) {
    display: block;
    padding-bottom: 20px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.secondary};
    margin-bottom: 30px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin-bottom: 0;
  }
`;

export const ResidenceInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 0;
  margin-top: 16px;

  @media (min-width: ${Breakpoints.desktop}px) {
    padding-top: 16px;
    border-top: 1px solid ${({ theme }) => theme.colors.border.primary};
  }
`;

export const BuildingInfoItem = styled(Typography)`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const ResidenceDot = styled.span`
  margin: 0 10px;
  color: ${({ theme }) => theme.colors.border.secondary};
  font-weight: bold;
`;
